/**
 * WssSelect Component
 * Dropdown for selecting WSS with loading states
 */

import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { LOADING_STATES, WSS_PLACEHOLDER } from "../utils/wssConstants";
import "@components/Common/SearchableSelect.css";

const WssSelect = ({
  wssOption,
  selectLatLong,
  isWssData,
  onChange,
  disabled = false,
}) => {
  // Determine options based on loading state
  const getOptions = () => {
    if (isWssData === LOADING_STATES.LOADING) {
      return [
        {
          CustomerName__c: "Loading...",
          Customer_Code__c: "",
        },
      ];
    }

    if (isWssData === LOADING_STATES.NO_DATA) {
      return [
        {
          CustomerName__c: "No Data",
          Customer_Code__c: "",
        },
      ];
    }

    return wssOption || [];
  };

  return (
    <Autocomplete
      id="wss-select"
      className="myDealer__categorySelect"
      options={getOptions()}
      getOptionLabel={(option) => {
        if (option?.CustomerName__c) {
          return `${option?.CustomerName__c}${
            option?.Customer_Code__c ? " : " : ""
          }${option?.Customer_Code__c || ""}`;
        }
        return "";
      }}
      value={selectLatLong}
      onChange={(event, newValue) => {
        onChange(newValue || WSS_PLACEHOLDER);
      }}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} placeholder="Select Wss Name" />
      )}
    />
  );
};

export default WssSelect;
